module.exports = __webpack_public_path__ + "img/x.58d27b60.svg";